import React, { FC, useState } from "react";

import { Props, defaultData } from "./types";
import CitySearchSelect from "./CitySearchSelect";

const WeatherSettings: FC<Props> = ({ data = defaultData, setData }) => {
  const handleCityChange = (selectedValue: string) => {
    setData({ ...data, city: selectedValue });
  };
  return (
    <div>
      <label>
        City
        <CitySearchSelect
          onChange={handleCityChange}
        />
      </label>
    </div>
  );
}

export default WeatherSettings;
